"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Portal = void 0;

var _react = require("react");

var _reactDom = _interopRequireDefault(require("react-dom"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DEFAULT_NODE = document.getElementById("root"); // Portal -- Using React Class Component

var Portal = function Portal(_ref) {
  var _ref$container = _ref.container,
      container = _ref$container === void 0 ? DEFAULT_NODE : _ref$container,
      children = _ref.children,
      className = _ref.className;
  var el = (0, _react.useMemo)(function () {
    var element = document.createElement("div");
    element.className = className;
    return element;
  }, []);
  (0, _react.useEffect)(function () {
    container.appendChild(el);
    return function () {
      container.removeChild(el);
    };
  }, []);
  (0, _react.useEffect)(function () {
    el.className = className || "";
  }, [className]);
  return /*#__PURE__*/_reactDom["default"].createPortal(children, el);
};

exports.Portal = Portal;
var _default = Portal;
exports["default"] = _default;